import React from "react";
import { Navigate } from "react-router-dom";

const PublicRoute = ({ children }) => {
    const profile = JSON.parse(localStorage.getItem("cred"));
    return profile === null ? children : <Navigate to="/dashboard" />;
};

export default PublicRoute;
